/* Single image */
import img1 from '../images/service/1.jpg';
import img2 from '../images/service/2.jpg';
import img3 from '../images/service/3.jpg';
import img4 from '../images/service/2.jpg';

import Simg1 from '../images/service-single/s1.jpg';
import Simg2 from '../images/service-single/s2.jpg';
import Simg3 from '../images/service-single/s3.jpg';
import Simg4 from '../images/service-single/s4.jpg';
import Gimg1 from '../images/service-single/s5.jpg';
import Gimg2 from '../images/service-single/s6.jpg';
import Gimg3 from '../images/service-single/s7.jpg';
import Gimg4 from '../images/service-single/s8.jpg';
import Gimg5 from '../images/service-single/s9.jpg';

const Services = [
  {
    id: 1,
    image: img1,
    simag: Simg1,
    gallery: [Gimg1, Gimg2, Gimg3, Gimg4],
    iconName: 'flaticon-road-with-broken-line',
    subtitle: 'Road Transport',
    title: 'Road Freight',
    description:
      'Reliable road freight for safe, timely local and regional deliveries.',
    overview:
      'Road freight is the most flexible option for regional distribution, cross-border delivery, and final-mile transport. We coordinate trucks, timelines, and handover points so cargo moves steadily from pickup to destination.',
    details:
      'Our team plans the route around cargo type, border requirements, and delivery window. That means fewer delays, fewer touchpoints, and better control over the shipment from dispatch to arrival.',
    focusTitle: 'What we manage',
    focusPoints: [
      'Pickup scheduling and truck allocation',
      'Regional and cross-border movement planning',
      'Milestone tracking and delivery confirmation',
    ],
    approachTitle: 'How we execute road freight',
    approachSteps: [
      {
        title: 'Route planning',
        text:
          'We review the cargo, destination, and delivery window before the truck is assigned so the route stays practical and efficient.',
      },
      {
        title: 'Dispatch control',
        text:
          'Pickup timing, border movement, and handover checks are coordinated to keep the shipment on the planned sequence.',
      },
      {
        title: 'Delivery confirmation',
        text:
          'We close the movement with milestone updates so your team knows exactly when the cargo reaches the consignee.',
      },
    ],
    benefitsTitle: 'Why clients use road freight',
    benefits: [
      'Direct movement with fewer handoffs',
      'Practical for regional and domestic delivery',
      'Flexible for urgent or scheduled shipments',
    ],
    useCasesTitle: 'Typical road freight use cases',
    useCases: [
      'Store replenishment and branch distribution',
      'Cross-border cargo with controlled delivery windows',
      'Door-to-door shipments that need direct transit',
    ],
    videoTitle: 'Why road freight works well',
    videoText:
      'Road transport is ideal for domestic distribution, urgent transfers, and cargo that needs direct delivery without multiple handovers.',
    videoPoints: [
      'Flexible routing for short and medium distances',
      'Better control for time-sensitive cargo',
      'Suitable for door-to-door delivery needs',
    ],
    quote:
      'Road freight gives us the control to keep cargo moving with dependable timing and direct delivery.',
    faq: [
      {
        title: 'When should I choose road freight?',
        content:
          'Choose road freight when you need direct movement, flexible routing, or regional delivery with fewer transfer points.',
      },
      {
        title: 'Can road freight support time-sensitive cargo?',
        content:
          'Yes. We plan pickup and delivery windows carefully so urgent shipments stay on schedule.',
      },
      {
        title: 'Do you provide tracking for road shipments?',
        content:
          'Yes. Road shipments are tracked through milestones so you can follow dispatch, transit, and delivery updates.',
      },
    ],
    slug: 'road-freight',
  },
  {
    id: 2,
    image: img2,
    simag: Simg2,
    gallery: [Gimg2, Gimg3, Gimg4, Gimg5],
    iconName: 'flaticon-air-plane',
    subtitle: 'Air Transport',
    title: 'Air Freight',
    description:
      'Fast air freight for urgent and time-sensitive shipments worldwide.',
    overview:
      'Air freight is the best fit for urgent cargo, high-value goods, and shipments that need the fastest possible transit time. We manage booking, documentation, and cargo coordination with the airline.',
    details:
      'We align schedules, cutoff times, and handling requirements so the shipment reaches the airport, moves on the booked flight, and arrives with the least possible delay.',
    focusTitle: 'What we manage',
    focusPoints: [
      'Flight booking and shipment coordination',
      'Export documentation support',
      'Airport handling and arrival follow-up',
    ],
    approachTitle: 'How we execute air freight',
    approachSteps: [
      {
        title: 'Booking and cutoff planning',
        text:
          'We align the shipment with flight schedules, cutoff times, and handling rules so the cargo reaches the airport on time.',
      },
      {
        title: 'Document coordination',
        text:
          'We check the export paperwork and make sure the shipment is ready for airline acceptance without avoidable delays.',
      },
      {
        title: 'Arrival follow-up',
        text:
          'Once the cargo lands, we follow through on status, release timing, and next-step delivery if required.',
      },
    ],
    benefitsTitle: 'Why clients use air freight',
    benefits: [
      'Fastest mode for time-critical cargo',
      'Useful for high-value and sensitive shipments',
      'Strong fit for global movements with tight deadlines',
    ],
    useCasesTitle: 'Typical air freight use cases',
    useCases: [
      'Urgent replacement stock',
      'Samples and high-priority commercial cargo',
      'Seasonal shipments with strict arrival targets',
    ],
    videoTitle: 'Why air freight matters',
    videoText:
      'When speed is the priority, air freight offers the quickest route for time-critical cargo and valuable goods.',
    videoPoints: [
      'Fast transit for urgent movements',
      'Good fit for high-value or sensitive cargo',
      'Best option when delivery time is critical',
    ],
    quote:
      'Air freight is about speed, control, and keeping the shipment moving through a precise schedule.',
    faq: [
      {
        title: 'What type of cargo fits air freight?',
        content:
          'Air freight works best for urgent, light-to-medium weight, or high-value cargo that needs fast delivery.',
      },
      {
        title: 'Do you handle airport coordination?',
        content:
          'Yes. We support booking, cutoff timing, and status follow-up until the shipment is accepted and moved.',
      },
      {
        title: 'Is air freight always the fastest option?',
        content:
          'For international movement, yes. It is typically the fastest route when the shipment can meet air cargo requirements.',
      },
    ],
    slug: 'air-freight',
  },
  {
    id: 3,
    image: img3,
    simag: Simg3,
    gallery: [Gimg1, Gimg3, Gimg5, Gimg4],
    iconName: 'flaticon-boat-with-containers',
    subtitle: 'Ocean Transport',
    title: 'Ocean Freight',
    description:
      'Cost-effective ocean freight for international cargo movement.',
    overview:
      'Ocean freight is the core solution for international cargo that needs scale and cost efficiency. We coordinate container booking, carrier schedules, and milestone tracking across the voyage.',
    details:
      'Whether you are moving full container loads or consolidated shipments, we align the route with port requirements and shipping line schedules so the cargo stays on track.',
    focusTitle: 'What we manage',
    focusPoints: [
      'Container booking and vessel planning',
      'Origin and destination port coordination',
      'Transit updates through each milestone',
    ],
    approachTitle: 'How we execute ocean freight',
    approachSteps: [
      {
        title: 'Container and vessel planning',
        text:
          'We match the cargo to the right vessel schedule and container type so the booking fits the shipment volume and route.',
      },
      {
        title: 'Port coordination',
        text:
          'Export handover, terminal timing, and vessel cutoff details are aligned to keep the shipment moving through the port flow.',
      },
      {
        title: 'Voyage monitoring',
        text:
          'We keep track of the sailing milestones so you have visibility from departure through destination arrival.',
      },
    ],
    benefitsTitle: 'Why clients use ocean freight',
    benefits: [
      'Cost-efficient for larger cargo volumes',
      'Suitable for international trade lanes',
      'Flexible for full and consolidated loads',
    ],
    useCasesTitle: 'Typical ocean freight use cases',
    useCases: [
      'Import and export container movements',
      'Bulk commercial cargo with planned transit',
      'Recurring international supply lanes',
    ],
    videoTitle: 'Why ocean freight is practical',
    videoText:
      'Ocean freight is the right fit when you want dependable international movement with better cost control over larger cargo volumes.',
    videoPoints: [
      'Suitable for large or recurring shipments',
      'Efficient for international trade lanes',
      'Flexible for full and consolidated loads',
    ],
    quote:
      'Ocean freight gives cargo the balance of scale, cost efficiency, and predictable international movement.',
    faq: [
      {
        title: 'When is ocean freight the right choice?',
        content:
          'Choose ocean freight when the shipment is international, volume is important, and transit time can be planned in advance.',
      },
      {
        title: 'Can you track container milestones?',
        content:
          'Yes. We track movement from booking through port events and voyage milestones.',
      },
      {
        title: 'Can ocean freight be used with warehousing?',
        content:
          'Yes. We can coordinate cargo from warehouse to port and from port to destination delivery.',
      },
    ],
    slug: 'ocean-freight',
  },
  {
    id: 4,
    image: img4,
    simag: Simg4,
    gallery: [Gimg5, Gimg4, Gimg2, Gimg1],
    iconName: 'flaticon-warehouse',
    subtitle: 'Storage & Distribution',
    title: 'Warehousing',
    description:
      'Secure storage and handling for smooth distribution operations.',
    overview:
      'Warehousing supports storage, inventory control, and shipment preparation before cargo moves to the next stage of delivery. We keep stock organized and ready for dispatch.',
    details:
      'The service is designed for importers and exporters who need safer holding, faster release, and cleaner handover between transport legs.',
    focusTitle: 'What we manage',
    focusPoints: [
      'Inbound storage and inventory handling',
      'Order prep and dispatch support',
      'Linkage between transport and final delivery',
    ],
    approachTitle: 'How we execute warehousing',
    approachSteps: [
      {
        title: 'Receiving and storage',
        text:
          'Inbound cargo is logged, organized, and stored so stock stays accessible and ready for the next movement.',
      },
      {
        title: 'Inventory control',
        text:
          'We keep the handover structured so the right cargo is released on time and with fewer operational mistakes.',
      },
      {
        title: 'Dispatch preparation',
        text:
          'Warehoused cargo is prepared for road, air, or ocean movement with cleaner release and better dispatch readiness.',
      },
    ],
    benefitsTitle: 'Why clients use warehousing',
    benefits: [
      'Cleaner handoff between transport legs',
      'Better control over stock and release timing',
      'Useful for import, export, and distribution planning',
    ],
    useCasesTitle: 'Typical warehousing use cases',
    useCases: [
      'Short-term storage before final dispatch',
      'Inventory holding for inbound and outbound cargo',
      'Consolidation ahead of export or distribution',
    ],
    videoTitle: 'Why warehousing matters',
    videoText:
      'A well-managed warehouse keeps cargo ready, reduces handling delays, and supports smoother distribution.',
    videoPoints: [
      'Improves control before final delivery',
      'Supports consolidation and dispatch',
      'Helps reduce waiting time in the chain',
    ],
    quote:
      'Warehousing keeps the cargo organized so transport, delivery, and distribution run smoothly.',
    faq: [
      {
        title: 'Do you support short-term storage?',
        content:
          'Yes. We can support short-term and operational storage as part of a transport plan.',
      },
      {
        title: 'Can warehousing be combined with freight services?',
        content:
          'Yes. Warehousing is often used alongside road, air, or ocean freight to keep movement coordinated.',
      },
      {
        title: 'Why use warehousing in the shipment flow?',
        content:
          'It helps organize cargo, improve dispatch readiness, and create a cleaner handoff to the next leg.',
      },
    ],
    slug: 'warehousing',
  },
];

export default Services;
